import NeedHelp from '../../../sharedComponents/NeedHelp/NeedHelp';
import BackButton from '../../../sharedComponents/BackButton/BackButton';
import { ThemedView } from '../../../theme';
import { ColorTokens } from '@voltmoney/schema';
import Typography from '../../../sharedComponents/typography/Typography';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@routes/types';

type NavigationProps = NativeStackNavigationProp<PrivateStackParamList , keyof PrivateStackParamList>



const VerifyEmailHeader = ({ navigation , pageName } : { navigation : NavigationProps  , pageName? :keyof PrivateStackParamList}) => {
  return (
    <ThemedView justifyContent='space-between' bg='bg-surface-primary' borderBottomWidth={1} borderBottomColor='border-primary' g='md' p='lg' flexDirection='row' alignItems='center'>
      <BackButton pageName={pageName} navigation={navigation} />
      <NeedHelp />
    </ThemedView>
  );
};

export default VerifyEmailHeader;
